import { Button, Card, CardContent, Stack, Typography } from '@mui/material'
import React from 'react'
import StepHeader from './StepHeader'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { AxiosResponse } from 'axios'
import ReportService from '../../../APIs/PHP/APIs/ReportService'
import { format } from 'date-fns'
import { openPDFFile } from '../../../Functions/DownloadFile'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation } from 'react-query'
import { useUserContext } from '../../../Contexts/UserConfig'
import ModalValidateVanRun from '../Modals/ModalValidateVanRun'

function Step5Generate() {
  const { setError } = useMessagePopupContext()
  const { whoAmI } = useUserContext()

  const today = format(new Date(), 'yyyy-MM-dd')
  const mutateManifest = useMutation<any, AxiosResponse>({
    mutationFn: () => ReportService.getShippingManifestPDF(whoAmI, today),
    onSuccess: (data) => {
      openPDFFile(data, today)
    },
    onError: (err) => setError(err),
  })

  return (
    <Card
      variant="outlined"
      sx={{ flex: 1.5 }}
    >
      <CardContent>
        <StepHeader
          step={5}
          name={'Generate'}
        />
        <Stack gap={stackGap.col}>
          <Typography variant="body2">Run optional commands</Typography>
          <Stack gap={1 / 2}>
            <Button
              variant={'outlined'}
              size={'small'}
              onClick={() => mutateManifest.mutate()}
            >
              Generate Today's Manifest & Email
            </Button>
            <ModalValidateVanRun />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default Step5Generate
